import api from './api';

export interface IDatosMensuales {
    mes: number;
    totalVentas: number;
    totalCompras: number;
    cantidadVentas?: number;
    cantidadCompras?: number;
}

export interface IDashboardResumen {
    ventasMes: number;
    comprasMes: number;
    cantidadVentas?: number;
    cantidadCompras?: number;
    totalCobradoMes: number;
    totalPagadoMes: number;
    /** Promedio de días para cobrar (cobranzas/ventas). */
    diasPromedioPagoCobranzas?: number;
    /** Promedio de días para pagar (compras). */
    diasPromedioPagoCompras?: number;
    datosMensuales: IDatosMensuales[];
}

export interface DashboardParams {
    mes?: number;
    año?: number;
    trimestre?: number;
}

export const getDashboardResumen = async (params?: DashboardParams): Promise<IDashboardResumen> => {
    try {
        console.log('Iniciando llamada a getDashboardResumen', params);
        const response = await api.get<IDashboardResumen>('/api/Dashboard/resumen', {
            params: params
        });
        console.log('Respuesta recibida:', response.data);
        return response.data;
    } catch (error: any) {
        console.error('Error en getDashboardResumen:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
        });
        throw error;
    }
}; 